import React from 'react';
import PropTypes from 'prop-types';

import { Table as MuiTable } from '@material-ui/core';

const Table = ({ children, ...rest }) => {
  return (
    <MuiTable
      {...rest}
    >
      { children }
    </MuiTable>
  )
}

Table.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Table;



// WEBPACK FOOTER //
// ./src/components/base/Table/Table.js